import Transition from '@ember/routing/-private/transition';
import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import ImportModel, { ImportState } from 'cio/models/import';
import PreviewController from 'cio/pods/imports/import/setup/preview/controller';
import ConfirmChangesService from 'cio/services/confirm-changes';

export default class PreviewRoute extends Route {
  @service confirmChanges!: ConfirmChangesService;

  crumb() {
    return {
      name: 'Preview',
      path: this.routeName,
    };
  }

  setupController(controller: PreviewController, model: ImportModel, transition: Transition) {
    super.setupController(controller, model, transition);

    this.confirmChanges.register(controller, this);
  }

  redirect(model: ImportModel) {
    if (model.state === ImportState.Failed) {
      return this.router.transitionTo('imports.import.setup.index', model);
    }

    return;
  }
}
